import { EthNftSmartContractVerify, TokenSmartContractInteraction } from "src/models";
import { Credentials } from "src/models/instantiateClass";
import { EthNftCreateCollection } from "src/models/modelsEthNft/EthNftCreateCollection";
import { EthNftMint } from "src/models/modelsEthNft/EthNftMint";
import { EthGetAbi } from "src/models/modelsEthSmartContract/getAbi";
import { EthGetAbiFunctions } from "src/models/modelsEthSmartContract/getAbiFunctions";
import { EthGetTxStatus } from "src/models/modelsEthSmartContract/getStatus";
import { EthTokenCreate } from "src/models/modelsEthToken/EthTokenCreate";
import { EthTokenSmartContractVerify } from "src/models/modelsEthToken/EthTokenSmartContractVerify";
import { EthTransfer } from "src/models/modelsEthToken/EthTransfer";
import { axiosRequest } from "./axiosCore";
import { extractValues } from "./extractValues";

export const ethTokenCreate = async (payload: EthTokenCreate, initialize: Credentials) => {
   return await axiosRequest('/eth/token/mint', payload, initialize);
}

export const ethTokenTransfer = async (payload: EthTransfer, initialize: Credentials) => {
    return await axiosRequest('/eth/token/transfer', payload, initialize);
 }

 export const ethTokenVerify = async (payload: EthTokenSmartContractVerify, initialize: Credentials) => {
    return await axiosRequest('/eth/token/smartContract/verify', payload,initialize);
 }

 export const ethNftVerify = async (payload: EthNftSmartContractVerify, initialize: Credentials) => {
   return await axiosRequest('/eth/nft/smartContract/verify', payload,initialize);
}

 export const ethNftCreateCollection = async (payload: EthNftCreateCollection, initialize: Credentials) => {
   return await axiosRequest('/eth/nft/createCollection', payload,initialize);
}

export const ethNftMint = async (payload: EthNftMint, initialize: Credentials) => {
   return await axiosRequest('/eth/nft/mintNft', payload,initialize);
}


export const ethGetAbiFunctions = async (payload: EthGetAbiFunctions, initialize: Credentials) => {
   return await axiosRequest('/eth/smartContract/getAbiFunctions', payload,initialize);
}


export const ethNftGetAbi = async (payload: EthGetAbi, initialize: Credentials) => {
   return await axiosRequest('/eth/smartContract/getAbi', payload,initialize);
}

export const ethGetTxStatus = async (payload: EthGetTxStatus, initialize: Credentials) => {
   return await axiosRequest('/eth/transactions/status', payload,initialize);
}

export const ethTokenSmartContractInteraction =  async (payload: TokenSmartContractInteraction, initialize: Credentials) => {
   const parameters = extractValues(payload.parameters)
   const modifiedPayload = {
       ...payload,
       parameters
   } 
   console.log(modifiedPayload)
   console.log(initialize)
   return await axiosRequest('/eth/token/buildContractInteraction', modifiedPayload, initialize)
}

